import React from "react";
import { Alert, Spinner } from "react-bootstrap";
import FeedbackReportCard from "../Robust Components/FeedbackReportCard";

const BugReportsTab = ({
  feedbackReports,
  feedbackLoading,
  users,
  handleOpenFeedback,
  handleMarkFeedbackAsRead,
}) => {
  return (
    <>
      <div className="pane-header">
        <h2 className="pane-title">משוב משתמשים</h2>
        <p className="pane-subtitle">ניהול משוב משתמשים</p>
      </div>
      <div className="bug-reports-container">
        {feedbackLoading ? (
          <div className="text-center p-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">טוען...</span>
            </Spinner>
          </div>
        ) : feedbackReports.length === 0 ? (
          <Alert variant="info" className="text-center">
            אין משובים כרגע
          </Alert>
        ) : (
          <div className="bug-reports-list">
            {feedbackReports.map((feedback) => (
              <FeedbackReportCard
                key={feedback.id}
                feedback={feedback}
                onOpen={handleOpenFeedback}
                onMarkAsRead={handleMarkFeedbackAsRead}
                users={users}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default BugReportsTab;
